<script>
import { mapState, mapActions } from "vuex";
import Loading from "@/components/layout/Loading.vue";
import IconTransporte from "@/assets/img/icon/section/IconTransporte.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import Modal from "@/components/Modal.vue";
export default {
  name: "Transporte",
  components: {
    Loading,
    IconTransporte,
    ConfirmModal,
    Modal,
  },

  data() {
    return {
      id_planificacion: [],
      default_color: "#fff",
      butonActive: true,
      loading: true,
      cancelAlert: false,
      showModal: false,
      selectedPlanificacion: null,
      idSolicitud: null,
      id_empresa: this.$ls.get("user").id_empresa_fk,
      id_usuario: this.$ls.get("user").id_usuario,
    };
  },

  computed: {
    ...mapState("TransporteModule", ["planificaciones", "solicitudes"]),
    solicitudesHechas() {
      return this.solicitudes.length !== 0;
    },
  },

  async created() {
    await this.getTransporte();
    await this.getSolicitudes();
  },

  methods: {
    ...mapActions("TransporteModule", [
      "getPlanificacionTransporte",
      "getSolicitudesTransporte",
      "cancelSolicitud",
    ]),

    cancelReq(idSolicitud) {
      if (idSolicitud)
        this.cancelSolicitud({
          idSolicitud:idSolicitud,
          idEmpresa: this.id_empresa,
          idUsuario: this.id_usuario,
        }).then(() => {
          this.getSolicitudes();
          this.cancelAlert = false;
        });
    },

    async getTransporte() {
      this.loading = true;
      const res = await this.getPlanificacionTransporte({
        id_empresa: this.id_empresa,
      });
      if (!res) this.toastGenericError();
      this.loading = false;
    },

    async getSolicitudes() {
      this.loading = true;
      const res = await this.getSolicitudesTransporte({
        id_empresa: this.id_empresa,
        id_usuario: this.id_usuario,
      });

      if (!res) this.toastGenericError();
      this.loading = false;
    },
    getAllSolicitudByPlanId(planificacionId) {
      const solicitudes = this.solicitudes.filter(
        (s) =>
          s.transporte_tramo.transporte_planificacion.id_planificacion ===
          planificacionId
      ).sort((a, b) =>
        new Date(a.fecha_creacion) - new Date(b.fecha_creacion)
      );
      return solicitudes;
    },
    getSolicitudByPlanId(planificacionId) {
      const solicitud = this.solicitudes.find(
        (s) =>
          s.transporte_tramo.transporte_planificacion.id_planificacion ===
          planificacionId
      );
      return solicitud;
    },

    toDate(date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);

      return this.capitalizeFirstLetter(
        newDate.toLocaleString("es-CL", {
          day: "numeric",
          month: "long",
          year: "numeric",
          weekday: "long",
        })
      ).replace(/,/g, "");
    },

    aPlanes() {
      this.butonActive = true;

      document.querySelector(".transporte__planes").classList.remove("d-none");
      document.querySelector(".transporte__historial").classList.add("d-none");
    },

    aHistorial() {
      this.butonActive = false;
      document.querySelector(".transporte__planes").classList.add("d-none");
      document
        .querySelector(".transporte__historial")
        .classList.remove("d-none");
    },

    handleClose() {
      this.showModal = false;
    },

    handleConfirm() {
      this.showModal = false;
    },

    openModalData(planificacion) {
      const solicitudes = this.getAllSolicitudByPlanId(
        planificacion.id_planificacion
      );
      this.selectedPlanificacion = { ...planificacion, solicitudes };
      this.showModal = true;
    },
  },
};
</script>

<template>
  <section id="transporte">
    <div class="row">
      <div class="col-12 mb-0">
        <h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
          <IconTransporte class="me-2 icon-svg-45" />
          Transporte
        </h1>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home" class="color-main">
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">Transporte</li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-12 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">
          ¡Agenda tu bus o vuelo de manera sencilla! Visualiza aquellos viajes que están disponibles para ti.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <Loading v-if="loading" pixeles="200px" />
        <div v-else class="row">
          <div v-for="planificacion in planificaciones" :key="planificacion.id_planificacion"
            class="col-12 col-lg-3 col-md-4 mb-3">
            <component :is="solicitudesHechas &&
              getAllSolicitudByPlanId(planificacion.id_planificacion)[0]
                ?.usuario === undefined
              ? 'span'
              : 'router-link'
              " class="card card-custom rounded-3 transition-all text-secondary h-100" :to="getAllSolicitudByPlanId(planificacion.id_planificacion)[0]
                ? ''
                : `/transporte/${planificacion.id_planificacion}`
                " :class="solicitudesHechas
                  ? 'cursor-default'
                  : 'card-shadow card-custom-border-hover'
                  ">
              <div class="card-body bg-transparent">
                <div class="d-flex h-100" :class="solicitudesHechas &&
                  getAllSolicitudByPlanId(planificacion.id_planificacion)[0]
                    ?.usuario === undefined
                  ? 'border-secondary'
                  : 'border-info'
                  ">
                  <div class="flex-grow-1">
                    <p class="lh-1 fs-5 pb-2 m-0">
                        {{ planificacion.nombre_planificacion }}
                    </p> 
                    <p class="font-700 my-auto" :class="{
                      'mb-0': getAllSolicitudByPlanId(
                        planificacion.id_planificacion
                      )[0],
                    }">
                      Salida:
                      <span class="text-opacity-75 font-400 mb-0">
                        {{ toDate(planificacion.fecha_viaje) }}
                      </span>
                      <br />Fechas de inscripción:<br />
                      Inicio <span class="text-opacity-75 font-400 mb-0">
                        {{ toDate(planificacion.fecha_inicio_inscripcion) }}
                      </span>
                      <br />
                      Fin <span class="text-opacity-75 font-400 mb-0">
                        {{ toDate(planificacion.fecha_fin_inscripcion) }}
                      </span>
                    </p>

                    <p v-if="
                      getAllSolicitudByPlanId(planificacion.id_planificacion)[0]
                    " class="color-main fst-italic mb-0">
                      Inscripción realizada. Asiento:
                      {{
                        getAllSolicitudByPlanId(planificacion.id_planificacion)[0]
                          .transporte_asiento.nombre_asiento
                      }}
                      <span class="ms-2">
                        <font-awesome-icon icon="fa-solid fa-eye" class="cursor-pointer"
                          @click="openModalData(planificacion)">
                        </font-awesome-icon>
                        <font-awesome-icon icon="fa-solid fa-trash" class="color-red ms-2 cursor-pointer" @click="() => {
                          idSolicitud = getAllSolicitudByPlanId(
                            planificacion.id_planificacion
                          ).map(item=>item.id_solicitud);
                          cancelAlert = true;
                        }
                          "></font-awesome-icon>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </component>
          </div>
        </div>
      </div>
    </div>
    <ConfirmModal :isVisible="cancelAlert" cancelText="Atrás" okText="Cancelar" :accept="() => {
      cancelReq(idSolicitud);
    }
      " :reject="() => {
        idSolicitud = null;
        cancelAlert = false;
      }
        ">
      ¿Estás seguro de que deseas <br />
      continuar con la cancelación?
    </ConfirmModal>
    <Modal :isVisible="showModal" title="Datos de la solicitud" size="modal-md" @confirm="handleConfirm"
      @close="handleClose">
      <article class="transport-details px-4 py-2" v-if="selectedPlanificacion">
        <!-- Detalles del Pasajero
        <section class="mb-4">
          <h2 class="fs-5 color-main">Detalles del Pasajero</h2>
          <div class="d-flex flex-column gap-3">
            <div class="d-flex border-bottom border-info">
              <span class="flex-grow-1 fw-bold"> Nombre </span>
              <span class="value">
                {{ selectedPlanificacion.usuario?.primer_nombre }}
                {{ selectedPlanificacion.usuario?.apellido_paterno }}
                {{ selectedPlanificacion.usuario?.apellido_materno }}
              </span>
            </div>
            <div class="d-flex border-bottom border-info">
              <span class="flex-grow-1 fw-bold"> RUT </span>
              <span class="value">
                {{ selectedPlanificacion.usuario?.rut_usuario }}-{{
                  selectedPlanificacion.usuario?.dv_usuario
                }}
              </span>
            </div>
            <div class="d-flex border-bottom border-info">
              <span class="flex-grow-1 fw-bold"> Cargo </span>
              <span class="value">{{
                selectedPlanificacion.usuario?.cargo[0]?.nombre_cargo
              }}</span>
            </div>
            <div class="d-flex border-bottom border-info">
              <span class="flex-grow-1 fw-bold"> Gerencia </span>
              <span class="value">{{
                selectedPlanificacion.usuario?.gerencia[0]?.nombre_gerencia
              }}</span>
            </div>
          </div>
        </section> -->
        <!-- Detalles del Viaje -->
        <h2 class="fs-5 fw-bold color-main">
          {{
            selectedPlanificacion.nombre_planificacion
          }}
        </h2>
        <div v-for="(soli, i) in selectedPlanificacion.solicitudes" :key="soli.id_solicitud">
          <section class="mb-2">
            <p class="fs-6 pt-2 fw-bold color-main mb-2">Detalles del Viaje <span>{{
              i == 0 ? ' de Ida' : i == 1 ? ' de Vuelta' : ''
            }}</span> </p>
            <div class="d-flex flex-column gap-2">
              <div class="d-flex border-bottom border-info">
                <span class="flex-grow-1 fw-bold"> Fecha de Viaje
                </span>
                <span class="value">{{
                  toDate(soli.transporte_tramo?.fecha_viaje)
                  }}</span>
              </div>
              <div class="d-flex border-bottom border-info">
                <span class="flex-grow-1 fw-bold"> Hora </span>
                <span class="value">{{
                  soli.transporte_tramo?.hora_viaje
                  }}</span>
              </div>
              <div class="d-flex border-bottom border-info">
                <span class="flex-grow-1 fw-bold"> Ruta </span>
                <span class="value">
                  {{
                    soli.transporte_tramo
                      ?.transporte_lista_destino?.nombre_origen
                  }}
                  →
                  {{
                    soli.transporte_tramo
                      ?.transporte_lista_destino?.nombre_destino
                  }}
                </span>
              </div>
            </div>
          </section>
          <!-- Datos del Transporte -->
          <section>
            <div class="d-flex flex-column gap-2">
              <div class="d-flex border-bottom border-info">
                <span class="flex-grow-1 fw-bold"> Tipo </span>
                <span class="value">
                  {{
                    soli.transporte_tramo
                      ?.transporte_lista_destino?.transporte_tipo_medio
                      ?.transporte_tipo?.nombre_transporte
                  }}
                </span>
              </div>
              <div class="d-flex border-bottom border-info">
                <span class="flex-grow-1 fw-bold"> Medio </span>
                <span class="value">
                  {{
                    soli.transporte_tramo
                      ?.transporte_lista_destino?.transporte_tipo_medio
                      ?.nombre_medio
                  }}
                </span>
              </div>
              <div class="d-flex border-bottom border-info">
                <span class="flex-grow-1 fw-bold"> Asiento </span>
                <span class="value">{{
                  soli.transporte_asiento?.nombre_asiento
                  }}</span>
              </div>
            </div>
          </section>
        </div>
      </article>
      <template #footer>
        <button class="btn btn-danger rounded-pill" @click="() => {
          idSolicitud = selectedPlanificacion.solicitudes.map(item=>item.id_solicitud);
          showModal = false;
          cancelAlert = true;
        }
          ">
          Cancelar Solicitud
        </button>
      </template>
    </Modal>
  </section>
</template>
